import { useMemo } from 'react';
import { GlCodeFormatType } from 'src/services/useGetGlMasks';
import { useGLCodeFormatErrors } from './useGLCodeFormatErrors';

const useGLCodeFormatDetailErrors = (
  glCodeFormats: GlCodeFormatType[],
  initialGlCodeFormats: GlCodeFormatType[]
) => {
  const { errors, warnings } = useGLCodeFormatErrors(glCodeFormats, initialGlCodeFormats);

  const errorList: string[] = [
    ...Object.values(errors)
      .map((i) => Object.values(i)?.flat())
      .flat()
      .map((item: any) => (typeof item === 'string' ? item : Object.values(item)?.flat()))
      .flat()
      .filter((item: any, i, arr) => arr.indexOf(item) === i),
  ] as string[];

  const hasErrors = useMemo(() => !!errorList.length, [errorList.length]);

  const warningList: string[] = [
    ...Object.values(warnings)
      .map((i) => Object.values(i)?.flat())
      .flat()
      .map((item: any) => (typeof item === 'string' ? item : Object.values(item)?.flat()))
      .flat()
      .filter((item: any, i, arr) => arr.indexOf(item) === i),
  ] as string[];

  const hasWarnings = useMemo(() => !!warningList.length, [warningList.length]);

  return {
    errors,
    errorList,
    hasErrors,
    warnings,
    warningList,
    hasWarnings,
  };
};

export default useGLCodeFormatDetailErrors;
